import { render, staticRenderFns } from "./ButtonSearch.vue?vue&type=template&id=3095f24a&scoped=true"
import script from "./ButtonSearch.vue?vue&type=script&lang=js"
export * from "./ButtonSearch.vue?vue&type=script&lang=js"
import style0 from "./ButtonSearch.vue?vue&type=style&index=0&id=3095f24a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3095f24a",
  null
  
)

export default component.exports